import type {RouteRecordRaw} from 'vue-router';
import {accountSettingsRoutes} from './account-settings.routes';
import {addressRoutes} from './addresses.routes';
import {analyticsRoutes} from './analytics.routes';
import {authRoutes} from './auth.routes';
import {casesRoutes} from './cases.routes';
import {collectTripRoutes} from './collect-trip.routes';
import {dashboardRoutes} from './dashboard.routes';
import {deliveryRoutes} from './delivery.routes';
import {fulfilmentRoutes} from './fulfilment.routes';
import {invoiceRoutes} from './invoices.routes';
import {locationFinderRoutes} from './location-finder.routes';
import {orderRoutes} from './orders.routes';
import {packagingsRoutes} from './packagings.routes';
import {pricesRoutes} from './prices.routes';
import {productRoutes} from './products.routes';
import {shipmentRoutes} from './shipments.routes';
import {shopSettingsRoutes} from './shop-settings/shop-setttings.routes';
import {subscriptionRoutes} from './subscriptions.routes';
import {tellAFriendRoutes} from './tell-a-friend.routes';
import {usersRoutes} from './users.routes';

export const routes: RouteRecordRaw[] = [
  ...authRoutes,
  ...analyticsRoutes,
  ...addressRoutes,
  ...productRoutes,
  ...orderRoutes,
  ...shipmentRoutes,
  ...collectTripRoutes,
  ...packagingsRoutes,
  ...deliveryRoutes,
  ...locationFinderRoutes,
  ...invoiceRoutes,
  ...shopSettingsRoutes,
  ...accountSettingsRoutes,
  ...subscriptionRoutes,
  ...tellAFriendRoutes,
  ...casesRoutes,
  ...usersRoutes,
  ...pricesRoutes,
  ...dashboardRoutes,
  ...fulfilmentRoutes,
  {
    name: 'not-found-page',
    path: '/:catchAll(.*)',
    redirect: {
      name: 'dashboard',
    },
  },
  {
    name: 'redirect',
    path: '/redirect',
    component: () => import('@/views/Empty.vue'),
    meta: {
      title: (t) => t('common.redirect'),
    },
  },
];
